module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAAAAXNSR0IArs4c6QAAAD9QTFRFAAAASUlhSkpgR1JmRU5iRE1eQkpjSFBgRUxgQkldQUhdQUleQkleQkhdQkleQkleQUhdQUheQkldQkheQUhd5oI2VQAAABR0Uk5TABUYGRoeHyAlsr/A0tjZ2t7f4OW/AI/0AAAA0UlEQVRIx+3W3Q6DIBQDYJ3IlP2o23n/Zx0hi6KjcLpb6S35EhNtsWlqas6R682io8GZgn3JAvTwlskUrADtrWR1sGkdbFY7EaC/VmSE2C5Ar/bRNaxWWaCVNqnVNqEJ+6Mpe9Ck3Wnaxpq3kf7DHjVn95q1sebt9o7gOmgsr2PL6r3l9PZdLbTe7MWyOrKZZSrZLrtrCkvpRAfVOtlfpQbdV2m4GxrtYI9Wja8bM8EO2jkc3Vv83OYJ+9vPBRs06r7Xeev1CHejH9v621VzknwAdPIp0gkogqoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/home_ic_close.png
// module id = R8Lz
// module chunks = 1